module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/passenger-auto-notif/passenger-auto-notif-datatable/passenger-auto-notif-datatable.component.css
// module id = ./src/app/components/passenger-auto-notif/passenger-auto-notif-datatable/passenger-auto-notif-datatable.component.css
// module chunks = main